import { useMemo } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import {
  ApiClient,
  createAuthMiddleware,
  createErrorNotificationMiddleware,
  createUnauthorizedMiddleware
} from '../services/apiClient';
import { LiveChatData } from '../types/client';

export const useApiClient = (chatData?: LiveChatData | null) => {
  const { token: authToken, logout } = useAuthContext();
  const { showNotification } = useNotification();

  // Prefer chatData.token (agent iframe) when available, otherwise use AuthContext token (backoffice/client)
  const token = chatData?.token ?? authToken ?? null;

  return useMemo(() => {
    const client = new ApiClient();
    client.use(createAuthMiddleware(() => token));
    client.use(createUnauthorizedMiddleware(logout));
    client.use(createErrorNotificationMiddleware(message => showNotification(message, 'error')));
    return client;
  }, [token, logout, showNotification]);
};

